import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseDataService, BaseUpdateComponent, NotificationService } from 'yt-ng-framework';
// import { NotificationsService } from 'angular2-notifications';
import { Validators } from '@angular/forms';
import { VrstaTelefona } from './vrsta-telefona';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-vrsta-telefona-update',
  templateUrl: './vrsta-telefona-update.component.html'
})
export class VrstaTelefonaUpdateComponent 
extends BaseUpdateComponent<VrstaTelefona> 
implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService

  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }


  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Naziv", Validators.required, 'required', 'VRSTATELEFONA.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("Naziv", Validators.maxLength(20), 'maxlength', 'VRSTATELEFONA.NAZIV.VALIDATION.MAXLENGTH');
    }
}
